// extracted by mini-css-extract-plugin
export default {"similarProducts":"similarProducts_similarProducts__iPPfR","similarProductsTitle":"similarProducts_similarProductsTitle__H6yBa"};